import { Routes } from '@angular/router';
import { HighcComponent } from './test/highc/highc.component';
import { AntiMartingalaComponent } from './views/anti-martingala/anti-martingala.component';
import { Bang1Component } from './views/bang1/bang1.component';
import { CambiaPasswordUtenteComponent } from './views/utenti/cambia-password-utente/cambia-password-utente.component';
import { DailyHiloComponent } from './views/daily/daily-hilo/daily-hilo.component';
import { HomeComponent } from './views/home/home.component';
import { LoginUtenteComponent } from './views/login-utente/login-utente.component';
import { NotFoundComponent } from './views/not-found/not-found.component';
import { RegistraDatiUtenteComponent } from './views/utenti/registra-dati-utente/registra-dati-utente.component';
import { DailyhiloBacktestComponent} from './views/daily/dailyhilo-backtest/dailyhilo-backtest.component'
import { BacktesterComponent } from './views/backtester/backtester.component';
import { AnalisiTsComponent } from './views/analisi-ts/analisi-ts.component';
import { DailyhiloDinamicBacktestComponent } from './views/daily/dailyhilo-dinamic-backtest/dailyhilo-dinamic-backtest.component';
import { DailyUpdateComponent } from './views/daily/daily-update/daily-update.component';
//import { UpdateComponent } from './views/daily/update/update.component';
import { SimulatorComponent } from './views/daily/simulator/simulator.component';
import { OperativeComponent } from './views/daily/operative/operative.component';
import { DaxtrendComponent } from './views/daxtrend/daxtrend.component';
import { PreferitiComponent } from './views/daily/preferiti/preferiti.component';
import { StoricoComponent } from './views/storico/storico.component';
import { SelezionatiComponent } from './views/selezionati/selezionati.component';
import { NuovoUtenteComponent } from './views/lista-utenti/nuovo-utente/nuovo-utente.component';
import { GestioneUtentiComponent } from './views/utenti/gestione-utenti/gestione-utenti.component';
import { ListaUtentiComponent } from './views/lista-utenti/lista-utenti.component';
import { GruppiUtentiComponent } from './views/utenti/gruppi-utenti/gruppi-utenti.component';
import { NuovoReportComponent } from './views/trading-reports/nuovo-report/nuovo-report.component';
import { ListaReportComponent } from './views/trading-reports/lista-report/lista-report.component';
import { AccountsComponent } from './views/trading-reports/accounts/accounts.component';
import { M45Component } from './views/reverse/m45/m45.component';
import { AnalisiComponent } from './views/crossover/analisi/analisi.component';
import { AnalisiM45Component } from './views/crossover/analisi-m45/analisi-m45.component';
import { AnalisiH1Component } from './views/crossover/analisi-h1/analisi-h1.component';
import { UltimiValoriM15Component } from './views/crossover/ultimi-valori-m15/ultimi-valori-m15.component';
import { UltimiValoriH1Component } from './views/crossover/ultimi-valori-h1/ultimi-valori-h1.component';
import { H1Component } from './views/crosstrend/h1/h1.component';
import { BacktestH1Component } from './views/crosstrend/backtest-h1/backtest-h1.component';
import { BacktestH4Component } from './views/crosstrend/backtest-h4/backtest-h4.component';
import { BacktestM15Component } from './views/crosstrend/backtest-m15/backtest-m15.component';
import { Crosstrend2BacktestH1Component } from './views/crosstrend2/crosstrend2-backtest-h1/crosstrend2-backtest-h1.component';
import { Crosstrend2BacktestH4Component } from './views/crosstrend2/crosstrend2-backtest-h4/crosstrend2-backtest-h4.component';
import { Crosstrend2BacktestM15Component } from './views/crosstrend2/crosstrend2-backtest-m15/crosstrend2-backtest-m15.component';
import { UltimiValoriH4Component } from './views/crossover/ultimi-valori-h4/ultimi-valori-h4.component';
import { XauComponent } from './views/crossover/xau/xau.component';
import { XauH1Component } from './views/crossover/xau-h1/xau-h1.component';
import { DonchianUltimiM15Component } from './views/donchian/ultimi-m15/ultimi-m15.component';
import { DonchianUltimiH1Component } from './views/donchian/donchian-ultimi-h1/donchian-ultimi-h1.component';
import { DonchianUltimiH4Component } from './views/donchian/donchian-ultimi-h4/donchian-ultimi-h4.component';
import { AsiaboComponent } from './views/asiabo/asiabo.component';
import { AsiaboCtComponent } from './views/asiabo-ct/asiabo-ct.component';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'home' },
  {path: 'highc', component:HighcComponent},
  {path: 'bang1', component:Bang1Component},
  {path: 'login', component:LoginUtenteComponent},
  {path: 'cambiaPassword', component:CambiaPasswordUtenteComponent},
  {path: 'registraUtente', component:RegistraDatiUtenteComponent},
  {path: 'home', component:HomeComponent},
  {path: 'antimartingala', component:AntiMartingalaComponent},
  {path: 'daily-hilo', component:DailyHiloComponent},
  {path: 'hilo-dinamic-backtest', component:DailyhiloDinamicBacktestComponent},
  {path: 'hilo-backtest', component:DailyhiloBacktestComponent},
  {path: 'update', component: DailyUpdateComponent},
  { path: 'backtester', component:BacktesterComponent},
  {path: 'analisi-ts', component:AnalisiTsComponent},
  {path: 'storico', component: StoricoComponent},
  {path: 'selezionati', component: SelezionatiComponent},
  {path: 'simulator', component: SimulatorComponent},
  {path: 'daily-operative', component: OperativeComponent},
  {path: 'daily-preferiti', component: PreferitiComponent},
  {path: 'dax-trend', component: DaxtrendComponent},
  {path: 'nuovo-utente', component: NuovoUtenteComponent},
  {path: 'gestione-utenti', component: GestioneUtentiComponent},
  {path: 'lista-utenti', component: ListaUtentiComponent},
  {path: 'gruppi-utenti', component: GruppiUtentiComponent},
  {path: 'nuovo-report', component: NuovoReportComponent},
  {path: 'lista-report', component: ListaReportComponent},
  {path: 'accounts', component: AccountsComponent},
  {path: 'reverse-m45', component: M45Component},
  {path: 'crossover-analisi', component: AnalisiComponent},
  {path: 'crossover-analisi-m45', component: AnalisiM45Component},
  {path: 'crossover-analisi-h1', component: AnalisiH1Component},
  {path: 'crossover-xau', component: XauComponent},
  {path: 'crossover-xau-h1', component: XauH1Component},
  {path: 'ultimi-valori-m15', component: UltimiValoriM15Component},
  {path: 'ultimi-valori-h1', component: UltimiValoriH1Component},
  {path: 'ultimi-valori-h4', component: UltimiValoriH4Component},
  {path: 'cross-trend-h1', component: H1Component},
  { path: 'crosstrend-backtest-h1', component: BacktestH1Component},
  { path: 'crosstrend-backtest-h4', component: BacktestH4Component},
  { path: 'crosstrend-backtest-m15', component: BacktestM15Component},
  {path: 'cross-trend-h1', component: H1Component},
  { path: 'crosstrend2-backtest-h1', component: Crosstrend2BacktestH1Component},
  { path: 'crosstrend2-backtest-h4', component: Crosstrend2BacktestH4Component},
  { path: 'crosstrend2-backtest-m15', component: Crosstrend2BacktestM15Component},
  { path: 'donchian/ultimi-m15', component: DonchianUltimiM15Component},
  { path: 'donchian/ultimi-h1', component: DonchianUltimiH1Component},
  { path: 'donchian/ultimi-h4', component: DonchianUltimiH4Component},
  { path: 'asia-bo', component: AsiaboComponent},
  { path: 'asiabo-ct', component: AsiaboCtComponent},
  { path: '**', component: NotFoundComponent },
];

